var map = {
	"./black-brush-theme.json": 18803,
	"./black-paint-theme.json": 1291,
	"./black-swirl-theme.json": 72556,
	"./black-wave-theme.json": 72684,
	"./blue-brush-theme.json": 62938,
	"./blue-paint-theme.json": 27174,
	"./blue-swirl-theme.json": 70449,
	"./blue-wave-theme.json": 40583,
	"./dblue-brush-theme.json": 78040,
	"./dblue-paint-theme.json": 32140,
	"./dblue-swirl-theme.json": 47847,
	"./dblue-wave-theme.json": 12877,
	"./default-theme.json": 45020,
	"./green-brush-theme.json": 25283,
	"./green-paint-theme.json": 4027,
	"./green-swirl-theme.json": 89052,
	"./green-wave-theme.json": 46172,
	"./orange-brush-theme.json": 75980,
	"./orange-paint-theme.json": 22856,
	"./orange-swirl-theme.json": 14659,
	"./orange-wave-theme.json": 21657,
	"./primary-theme.json": 59747,
	"./purple-brush-theme.json": 49116,
	"./purple-paint-theme.json": 28408,
	"./purple-swirl-theme.json": 42099,
	"./purple-wave-theme.json": 11913,
	"./red-brush-theme.json": 44835,
	"./red-paint-theme.json": 36635,
	"./red-swirl-theme.json": 99420,
	"./red-wave-theme.json": 68284,
	"./white-brush-theme.json": 58141,
	"./white-paint-theme.json": 28173,
	"./white-swirl-theme.json": 82038,
	"./white-wave-theme.json": 45838,
	"./yellow-brush-theme.json": 22090,
	"./yellow-paint-theme.json": 91510,
	"./yellow-swirl-theme.json": 22529,
	"./yellow-wave-theme.json": 82935
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15136;